import React from 'react';
import UnderConstructionPage from '../UnderConstructionPage';

export default function HealthCheck() {
  return (
    <UnderConstructionPage
      title="Admin • Automation Health Check"
      description="Phase 2: automation health and system checks."
    />
  );
}
